import { render } from "./FooterComponent.vue?vue&type=template&id=31e6bacc"
import script from "./FooterComponent.vue?vue&type=script&lang=js"
export * from "./FooterComponent.vue?vue&type=script&lang=js"

import "./FooterComponent.vue?vue&type=style&index=0&id=31e6bacc&lang=stylus"

import exportComponent from "C:\\projects\\_personal\\poland-shop\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__